module.exports = __webpack_public_path__ + "img/baerbock-buch-plagiat.6ae087be.png";